import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FiltroProcessoPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'filtroProcesso',
  pure: false
})
export class FiltroProcessoPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  
  transform(list: any, searchText: any): any {
    if(searchText == null) return list;

    return list.filter(function(item){
      return item.nrProcesso.indexOf(searchText) > -1;
    })
  }
}



// WEBPACK FOOTER //
// ./src/pipes/filtro-processo.ts